// extracted by mini-css-extract-plugin
module.exports = {"header":"Notifications_header__eEbo5","cuoponBody":"Notifications_cuoponBody__jeISm"};